module.exports = __webpack_public_path__ + "static/media/Category-Communities.d67abd53.jpg";